import React from 'react';
import PropTypes from 'prop-types';
import proposalsReducer from './reducer';

export const INITIAL_STATE = {
  pilot: false,
};

export const ProposalContext = React.createContext({});
ProposalContext.displayName = 'Proposal';

export const ProposalContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(proposalsReducer, INITIAL_STATE);
  const store = React.useMemo(() => ({ state, dispatch }), [state]);
  return <ProposalContext.Provider value={store}>{children}</ProposalContext.Provider>;
};

export const useProposalContext = () => {
  const { state, dispatch } = React.useContext(ProposalContext);
  return [state, dispatch];
};

ProposalContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
